import { createAction } from '@reduxjs/toolkit'

export const reset = createAction('web3provider/reset')
export const updateIsUserWalletConnected = createAction<{ isUserWalletConnected: boolean }>(
  'web3provider/updateIsUserWalletConnected',
)
export const updateSelectedChainNoUserWalletPresent = createAction<{ selectedChainNoUserWalletPresent: number }>(
  'web3provider/updateSelectedChainNoUserWalletPresent',
)
